export const config = {
  PartnersIntro: {
    title: 'Select a Stylist',
    description: `Our Personal Stylists have had extensive colour and fashion styling training.
    They study trends and styles and can adapt them to you and your lifestyle.
    Your Personal Stylist will find looks that work to create a wardrobe
    that's unique to you.`,
  },
};
